import Table from "../../components/Table/Table";
import {useEffect, useMemo, useState} from "react";
import Icon, {arrowIcon, settingsIcon} from "../../components/Icon/Icon";
import Button from "../../components/Button/Button";
import PageLayout from "../../components/PageLayout/PageLayout";
import SettingActions from "../../api/SettingsActions";

const Settings = () => {
    const [emails, setEmails] = useState([]);

    useEffect(() => {
        SettingActions.loadEmails(setEmails);
    }, []);

    const columns = useMemo(() => [
        {
            accessor: "emailTemplates",
            header: "Email templates",
            cell: ({row}) => {
                const name = row.original.name;
                return <span>{name}</span>;
            },
        },
        {
            accessorKey: 'actions',
            header: 'Actions',
            cell: ({row}) => {
                const id = row.original.id;
                return (
                    <div className="actions">
                        <Button variant="link" to={`/settings/${id}`}>
                            <p>view</p>
                            <Icon svg={arrowIcon}/>
                        </Button>
                    </div>
                )
            }

        }
    ], [emails]);


    return (
        <PageLayout
            titlePageContent='Settings'
            className='settings'
            icon={settingsIcon}
        >
            <Table data={emails} columns={columns}/>
        </PageLayout>
    )
}

export default Settings;